import { Injectable } from '@angular/core';
import { CommonapiService } from '../../Shared/Service/Commonapi.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PlanAddService {

constructor(public api: CommonapiService, public httpClient: HttpClient) { }

async GetFilterAutoCompleteDetails(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetFilterAutoCompleteDetails`,obj,isformupload);    
}

async GetFilteSearchResultValues(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetFiltePlanSearchResultValues`,obj,isformupload);    
}

async AddPlan(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/AddPlan`,obj,isformupload);    
}

async GetLocation() {
  return await this.api.getLocation();    
}

async GetCustomerMeeting(obj: any, isformupload: boolean) {
  return this.api.apiPost(false, `SalesLogin/GetCustomerMeeting`, obj, isformupload);
}

async AddDealPlan(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/AddDealPlan`,obj,isformupload);    
}

}
